import React from 'react';

import Carousel from 'react-multi-carousel';
import governingCouncil from '../../data/governingCouncil';

function GoverningCouncil() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1150 },
      items: 3.2
    },
    midi_desktop: {
      breakpoint: { max: 1150, min: 980 },
      items: 2.8
    },
    mini_desktop: {
      breakpoint: { max: 980, min: 890 },
      items: 2.5
    },
    tablet: {
      breakpoint: { max: 890, min: 770 },
      items: 2.1
    },
    midi_tablet: {
      breakpoint: { max: 770, min: 690 },
      items: 1.8
    },
    mini_tablet: {
      breakpoint: { max: 690, min: 540 },
      items: 1.5
    },
    mobile: {
      breakpoint: { max: 540, min: 485 },
      items: 1.1
    },
    midi_mobile: {
      breakpoint: { max: 485, min: 400 },
      items: 1
    },
    mini_mobile: {
      breakpoint: { max: 400, min: 0 },
      items: 1
    }
  };

  return (
    <section className="relative w-full mb-28 sm:mb-52">
      <div className="content">
        <div className="max-w-5xl mx-auto text-center mb-10 sm:mb-16">
          <h1 className="section-header">Meet The Governing Council Team</h1>
          <p className="big-p">
            The Purple Academy Governing Council institutes methodologies to meticulously
            assess the School&apos;s performance and efficacy. This involves furnishing guidance
            during the implementation of training curricula and establishing
            the overall direction for the academy.
          </p>
        </div>
        <div className="w-full">
          <Carousel
            arrows
            infinite
            autoPlay
            autoPlaySpeed={2500}
            responsive={responsive}
            centerMode={false}
            customTransition="transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
            transitionDuration={600}
            removeArrowOnDeviceType={['tablet', 'mobile']}
          >
            {governingCouncil.map((item) => (
              <div
                key={item.name}
                className="group mx-2 rounded-2xl overflow-hidden relative h-[400px] shadow-lg cursor-pointer"
              >
                <img
                  src={item.img}
                  alt={item.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                  style={{ objectPosition: item.objectPosition || 'top center' }}
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent transition-opacity duration-500" />
                <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-400">
                  <div className="h-[3px] bg-primary rounded-full mb-2 w-6 group-hover:w-12 transition-all duration-500" />
                  <h3 className="font-bold font-title text-white text-base leading-tight">{item.name}</h3>
                  <p className="text-[12px] text-white/80 leading-snug mt-0.5">{item.role}</p>
                  {item.role2 && (
                    <p className="text-[11px] text-white/60 leading-snug">{item.role2}</p>
                  )}
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
}

export default GoverningCouncil;
